import { Fragment, useEffect, useReducer, useRef, useState } from "react"
import useIsMobile from "../../../../hook/useIsMobile"
import Skeleton from "react-loading-skeleton"
import { Link, useNavigate } from "react-router-dom"
import InfoIcon from "../../../InfoIcon"
import { faCircleArrowDown } from "@fortawesome/free-solid-svg-icons"
import ToggleButton from "../../../ToggleButton"
import useRole from "../../../../hook/useRole"
import useFetch from "../../../../hook/useFetch"
import { notificationActions } from "../../../../store/notification-slice"
import { useDispatch, useSelector } from "react-redux"
import { orderActions } from "../../../../store/orders-slice"
import { userActions } from "../../../../store/user-slice"

export default function Order({ orders, user }) {


    const { isMobile } = useIsMobile()

    const [trorder, setTrOrder] = useState()


    useEffect(() => {
        if (orders) {
            let items = []

            Object.keys(orders).forEach(key => {
                let item = orders[key]

                items.push(
                    <Item key={key} item={item} user={user} />
                )
            })

            setTrOrder(items)
        }



    }, [orders])

    if (!trorder) {
        return <Skeleton count={50} />
    }

    return <div className={`right-col bg-white ${isMobile ? 'mt-3' : ''}`} >
        <table className="table table-striped table-bordered" >
            <thead>
                <tr>

                    <th>OrderID</th>
                    <th>Product</th>
                    <th>Details</th>
                </tr>
            </thead>
            <tbody>
                {trorder}
            </tbody>
        </table>
    </div>

}


function Item({ item, user }) {

    const [showDetails, setShowDetails] = useState()

    const componentReducer = (state, action) => {
        switch (action.type) {
            case 'order.active':
                return { ...state, active: !state.active }
            case 'order.start':
                return { ...state, start: action.data }
            case 'order.end':
                return { ...state, end: action.data }
        }
    }
    const [componentState, dispatchComponent] = useReducer(componentReducer, item)

    const { hasrole } = useRole('rsosuperuser')

    const { update, del } = useFetch()

    let dispatch = useDispatch()

    let token = useSelector(state => state.user.token)

    let navigate = useNavigate()



    return <Fragment>
        <tr >
            <td>{item.order_id}</td>
            <td><Link to={`/admin/products/${item.product_id}`} >{item.ptitle}</Link></td>
            <td><InfoIcon className='btn btn-outline-secondary' title='details' icon={faCircleArrowDown} onClick={() => {
                setShowDetails(!showDetails)
            }} /></td>
        </tr>

        {showDetails &&

            <Fragment>

                <tr>
                    <th>Activate</th>

                    <td colSpan={2} ><ToggleButton defaultChecked={componentState.active} onToggle={() => {
                        dispatchComponent({
                            type: 'order.active'
                        })
                    }} /></td>
                </tr>
                <tr>
                    <th>Start</th>
                    <td colSpan={2} ><input disabled={!hasrole} type='date' defaultValue={componentState.start} onInput={(e) => {
                        dispatchComponent({
                            type: 'order.start',
                            data: e.target.value
                        })
                    }} /></td>

                </tr>
                <tr>
                    <th>End</th>
                    <td colSpan={2}><input disabled={!hasrole} type='date' defaultValue={componentState.end} onInput={(e) => {
                        dispatchComponent({
                            type: 'order.end',
                            data: e.target.value
                        })
                    }} /></td>
                </tr>

                <tr>
                    <td colSpan={3}><button className="btn btn-secondary" type="button" onClick={() => {
                        if (window.confirm('user order will be change, are you sure to update? The processes are saved in log!!!')) {
                            update(`/admin/order?token=${token}`, {
                                active: componentState.active ? 1 : 0,
                                start: componentState.start,
                                end: componentState.end,
                                id: componentState.id,
                                order_id: componentState.order_id

                            }, null, () => {

                                dispatch(notificationActions.setNotification({
                                    message: `order updated`,
                                    status: true
                                }))


                                navigate('/admin/users', {
                                    state: {
                                        refetch: true
                                    }
                                })
                            })
                        }
                    }} >Update</button></td>
                </tr>

                <tr>
                    <td colSpan={3} >
                        <button type="button" disabled={!hasrole} className="btn btn-warning" onClick={() => {
                            if (window.confirm('user order will be change, are you sure to update? The processes are saved in log!!!')) {
                                del(`/admin/order?token=${token}`, { id: componentState.id }, (data) => {
                                    dispatch(notificationActions.setNotification({
                                        message: data,
                                        status: false
                                    }))
                                },
                                    () => {
                                        dispatch(notificationActions.setNotification({
                                            message: `order deleted`,
                                            status: true
                                        }))


                                        navigate(`/admin/users/${user.id}`, {
                                            state: {
                                                refetch: true
                                            }
                                        })
                                    })
                            }

                        }} >Delete</button>
                    </td>
                </tr>

            </Fragment>


        }
    </Fragment>
}